<script setup lang="ts"></script>

<template>
  <icon name="lucide:image-off" />
</template>

<style scoped></style>
